import {
  createFileRoute,
  notFound,
  Outlet,
  redirect,
} from "@tanstack/react-router"
import { GatedSessionDetailsFailReason } from "ipctg-inflow-types/InFlowEnums"

import { NOT_FOUND_SESSION } from "@/globalComponents/organisms/RootNotFound"
import { cleanEmptyParams } from "@/utilities/etc"
import { ExpectedError } from "@/utilities/expectedErrors"
import { sessionDetailsQueryOptions } from "@/utilities/hooks/queries/express"
import { fetchWelcomeToken } from "@/utilities/hooks/queries/shared"

export const Route = createFileRoute(
  "/qr/$qrLookupID/gated/register/$sessionID"
)({
  validateSearch: (
    search: Record<string, unknown>
  ): { reregister?: boolean; express?: boolean } => {
    return cleanEmptyParams({
      reregister: !!search.reregister,
      express: !!search.express,
    })
  },
  beforeLoad: async ({ context, params, search, matches }) => {
    if (
      matches.some(
        (m) =>
          m.routeId === "/qr/$qrLookupID/gated/register/$sessionID/complete" ||
          m.routeId === "/qr/$qrLookupID/gated/register/$sessionID/confirmation"
      )
    ) {
      return
    }

    const shouldRefetchWelcome = matches.some(
      (m) =>
        m.routeId ===
          "/qr/$qrLookupID/gated/register/$sessionID/confirmation" ||
        m.routeId === "/qr/$qrLookupID/gated/register/$sessionID/express"
    )

    if (shouldRefetchWelcome) {
      context.queryClient.clear()
      await fetchWelcomeToken({ qrLookupID: params.qrLookupID })
    }

    try {
      const rsp = await context.queryClient.fetchQuery(
        sessionDetailsQueryOptions({ sessionID: params.sessionID })
      )

      if (!search.reregister && rsp.session.isRegistered) {
        throw redirect({
          to: "/qr/$qrLookupID/gated/register/$sessionID/complete",
          params,
          search: {
            express: matches.some(
              (m) =>
                m.routeId ===
                "/qr/$qrLookupID/gated/register/$sessionID/express"
            ),
          },
        })
      }
    } catch (error) {
      if (
        error instanceof ExpectedError &&
        error.failReason === GatedSessionDetailsFailReason.SessionNotFound
      ) {
        throw notFound({
          data: {
            type: NOT_FOUND_SESSION,
          },
        })
      }
      throw error
    }
  },
  shouldReload: true,
  component: Outlet,
})
